(() => {
  if (customElements.get('ebt-location-stock')) return;

  class EbtLocationStock extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;

      this.output = this.querySelector('[data-stock-output]');
      this.config = JSON.parse(
        this.querySelector('[data-stock-config]').textContent
      );
      this.supplierOutput = this.querySelector('[data-supplier-output]');

const supplierData = this.querySelector('[data-supplier-statuses]');
this.supplierStatuses = supplierData
  ? JSON.parse(supplierData.textContent)
  : {};


      this.startWhenReady = () => this.start();

      if (document.readyState === 'loading') {
        document.addEventListener(
          'DOMContentLoaded',
          this.startWhenReady,
          { once: true }
        );
      } else {
        this.start();
      }
    }

    start() {
      if (!this.isConnected) return;

      this.load(this.dataset.variantId);

      // Use this theme's existing variant-change notifications.
      if (typeof subscribe === 'function') {
        this.unsubscribeVariant = subscribe('variant-change', (event) => {
          const data = event.data;

          if (String(data.sectionId) !== this.dataset.sectionId) return;

          this.load(data.variant?.id);
        });
      }

      // Remove the previous count as soon as an option changes.
      this.onOptionChange = (event) => {
        if (
          !event.target.closest('variant-selects') &&
          !event.target.closest('variant-radios')
        ) return;

        this.cancelRequest();
        if (this.supplierOutput) {
  this.supplierOutput.hidden = true;
}

        this.output.textContent = 'Checking in-store stock…';

        // If no valid variant-change event follows, don't leave
        // the previous variant's stock or an endless loading message.
        this.loadingTimeout = setTimeout(() => this.showError(), 10000);
      };

      this.productInfo = this.closest('product-info');
      this.productInfo?.addEventListener('change', this.onOptionChange);
    }

    cancelRequest() {
      this.controller?.abort();
      clearTimeout(this.loadingTimeout);
    }

    showError() {
      this.output.textContent =
        this.config.errorLabel || 'In-store availability unavailable';
    }
renderSupplier(variantId) {
  if (!this.supplierOutput) return;

  const id = String(variantId || '').split('/').pop();
  const status = this.supplierStatuses[id];

  // Missing means not initialized, not out of stock.
  if (status !== true && status !== false) {
    this.supplierOutput.hidden = true;
    this.supplierOutput.textContent = '';
    return;
  }

  this.supplierOutput.textContent = status
    ? 'Supplier Stock: In Stock'
    : 'Supplier Stock: Out of Stock';

  this.supplierOutput.hidden = false;
}

    async load(variantId) {
      this.cancelRequest();
      this.renderSupplier(variantId);


      const token = String(this.config.token || '').trim();
      const rawLocationId = String(this.config.locationId || '').trim();

      if (!variantId || !token || !rawLocationId) {
        this.showError();
        return;
      }

      const locationId = rawLocationId.startsWith('gid://')
        ? rawLocationId
        : `gid://shopify/Location/${rawLocationId}`;

      const variantGid = String(variantId).startsWith('gid://')
        ? String(variantId)
        : `gid://shopify/ProductVariant/${variantId}`;

      const controller = new AbortController();
      this.controller = controller;

      this.output.textContent = 'Checking in-store stock…';

      const requestTimeout = setTimeout(() => {
        controller.abort();
        if (this.isConnected) this.showError();
      }, 10000);

      try {
        const response = await fetch('/api/2026-10/graphql.json', {
          method: 'POST',
          signal: controller.signal,
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token
          },
          body: JSON.stringify({
            query: `
              query LocationStock($id: ID!) {
                node(id: $id) {
                  ... on ProductVariant {
                    storeAvailability(first: 100) {
                      nodes {
                        location { id }
                        quantityAvailable
                      }
                    }
                  }
                }
              }
            `,
            variables: { id: variantGid }
          })
        });

        if (!response.ok) throw new Error('Request failed');

        const result = await response.json();
        if (result.errors?.length) throw new Error('Query failed');

        const locations = result.data?.node?.storeAvailability?.nodes;
        if (!Array.isArray(locations)) throw new Error('Missing data');

        const location = locations.find(
          entry => entry.location.id === locationId
        );

        if (!location || !Number.isInteger(location.quantityAvailable)) {
          throw new Error('Location quantity unavailable');
        }

        if (controller.signal.aborted || !this.isConnected) return;

        this.renderQuantity(location.quantityAvailable);
      } catch (error) {
        if (!controller.signal.aborted && this.isConnected) {
          this.showError();
        }
      } finally {
        clearTimeout(requestTimeout);
      }
    }

    renderQuantity(rawQuantity) {
      const quantity = Math.max(0, rawQuantity);
      const threshold = Number(this.config.threshold) || 0;
      const lowStock = quantity > 0 && quantity <= threshold;

      const dot = document.createElement('span');
      dot.setAttribute('aria-hidden', 'true');
      dot.style.cssText =
        'display:inline-block;width:9px;height:9px;' +
        'border-radius:50%;margin-right:8px;';
      dot.style.backgroundColor = quantity === 0
        ? 'rgb(200, 200, 200)'
        : lowStock
          ? 'rgb(238, 148, 65)'
          : 'rgb(62, 214, 96)';

      const label = this.config.label || 'In store';
      const status = this.config.showCount
        ? String(quantity)
        : quantity === 0
          ? 'Out of stock'
          : lowStock
            ? 'Low stock'
            : 'In stock';

      this.output.replaceChildren(
        dot,
        document.createTextNode(`${label}: ${status}`)
      );
    }

    disconnectedCallback() {
      document.removeEventListener(
        'DOMContentLoaded',
        this.startWhenReady
      );
      this.cancelRequest();
      this.unsubscribeVariant?.();
      this.productInfo?.removeEventListener('change', this.onOptionChange);
      this.started = false;
    }
  }

  customElements.define('ebt-location-stock', EbtLocationStock);
})();
